import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
import './vee-validate'

Vue.config.productionTip = false

axios.defaults.withCredentials = true
axios.defaults.timeout = 5000

axios.defaults.baseURL = (
  process.env['VUE_APP_API_URL'] == undefined ?
    'https://'+window.location.hostname.replace(/^([a-z0-9\-]+)/, 'api')+'/pub' :
    process.env['VUE_APP_API_URL']
)

new Vue({
  render: h => h(App)
}).$mount('#app')
